import integrationData from './integration-search-suggestion';

const searchContainer = document.querySelector('.search-container');
const searchField = searchContainer.querySelector('#search-field');
const clearButton = searchContainer.querySelector('.close-icon');
const dropDownSuggestions = searchContainer.querySelector('.suggestions ul');

const resultsContainer = document.querySelector('.results-container');
const resultMsgInner = resultsContainer.querySelector('.result-msg');
const similarMsg = resultsContainer.querySelector('.similar-msg');
const integrationForm = resultsContainer.querySelector('#integration-form');
const integResult = resultsContainer.querySelector('.integration-result');

const listItems = document.querySelectorAll('.integration-list-wrapper .list-item');
const cardList = document.querySelector('.integration-card-list');
let blurTimeout;

// search field input mapping with integration card data
function search(str) {
  const results = [];
  const val = str.toLowerCase();

  if (val.trim().length === 0) return results;

  integrationData.forEach((value) => {
    if (value.integration.toLowerCase().indexOf(val) > -1) {
      results.push(value.integration);
    }
  });
  return results;
}

// depend on search input entered, showing search result
// search dropdown & simialr msg handled
function showSuggestions(results, inputVal) {
  if (inputVal === '' || results === 0) {
    dropDownSuggestions.innerHTML = '';
    dropDownSuggestions.classList.remove('has-suggestions');
    return;
  }
  if (results.length > 0) {
    const dropdownList = integrationData
      .filter(data => data.integration.toLowerCase().startsWith(inputVal.toLowerCase()))
      .map(data => `<li class="suggest suggest-list fx fx--cv">
              <img class="mr-2" src="https://assets.lexreception.com/lexreception/images/logos/${data.icon}.svg" alt="${data.integration} icon" width="24">
              <span class="text text--lg">${data.integration}</span>
          </li>`).join('');
    dropDownSuggestions.innerHTML = dropdownList;
    similarMsg.innerHTML = `<p class="text text--xl-d text--lg bold">Popular integrations</p>
    <button id="showSimilarIntegrationsList" class="action action--lg action--arrow tc-action">View all <svg class="icon-arrow"
            width="24" height="24" fill="#006EC8">
            <use xlink:href="#arrow-icon"></use>
        </svg></button>`;
    dropDownSuggestions.classList.add('has-suggestions');

    clearTimeout(blurTimeout);

    document
      .querySelector('#showSimilarIntegrationsList')
      .addEventListener('click', () => document.querySelector('[data-category-id="popular-card"]').click());
  } else {
    dropDownSuggestions.innerHTML = `<div id="suggestionDropdownList"><li class="suggest suggest-not">
        <p class="text text--lg">No results found for <span class="bold">&#8220;${inputVal}&#8221;</span></p>
    </li>
    <li class="suggest"><button class="action action--lg action--arrow tc-action">Request new integration <svg class="icon-arrow" width="24" height="24" fill="#006EC8"><use xlink:href="#arrow-icon"></use></svg></button></li></div>`;
    similarMsg.innerHTML = '';
    dropDownSuggestions.classList.add('has-suggestions');
  }
}

// using search dropdown for search input value
function useSuggestion(event) {
  const listItem = event.target.closest('li');
  if (!listItem || !listItem.querySelector('.text--lg')) {
    dropDownSuggestions.innerHTML = '';
    dropDownSuggestions.classList.remove('has-suggestions');
    return;
  }
  const suggestionText = listItem.querySelector('.text--lg').textContent;
  if (listItem.querySelector('.text--lg').classList.contains('suggest-not')) {
    searchField.value = '';
  } else {
    searchField.value = suggestionText.toLowerCase();
  }
  dropDownSuggestions.innerHTML = '';
  dropDownSuggestions.classList.remove('has-suggestions');
}

// search field clear button event
clearButton.addEventListener('click', () => {
  searchField.value = '';
  dropDownSuggestions.innerHTML = '';
  dropDownSuggestions.classList.remove('has-suggestions');
});

let debounceTimer;
// search input entered event handled
searchField.addEventListener('input', () => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    const results = search(searchField.value);
    showSuggestions(results, searchField.value);
  }, 300);
});

// search field input enter event
searchField.addEventListener('keydown', (event) => {
  if (event.keyCode === 13) {
    dropDownSuggestions.classList.remove('has-suggestions');
    cardList.classList.add('d-none');
  }
});

// sidebar category list items
listItems.forEach((listItem) => {
  listItem.addEventListener('click', () => {
    cardList.classList.remove('d-none');
    similarMsg.classList.add('d-none');
    resultMsgInner.innerHTML = '';
    document.querySelector('.search-result').innerHTML = '';
    document.querySelector('.similar-result').classList.add('d-none');
    integrationForm.classList.add('d-none');
    integResult.classList.remove('d-none');
  });
});

// keyboard up and down arrow keys and enter key handle for search field dropdown use case
function handleArrowKeys(event) {
  const activeSuggestion = dropDownSuggestions.querySelector('.active');
  // if the up arrow key was pressed
  if (event.keyCode === 38) {
    event.preventDefault();
    if (activeSuggestion && activeSuggestion.previousSibling) {
      activeSuggestion.classList.remove('active');
      activeSuggestion.previousSibling.classList.add('active');
      activeSuggestion.previousSibling.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    } else if (!activeSuggestion) {
      dropDownSuggestions.lastChild.classList.add('active');
      dropDownSuggestions.lastChild.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    }
  }
  // if the down arrow key was pressed
  if (event.keyCode === 40) {
    event.preventDefault();
    if (activeSuggestion && activeSuggestion.nextSibling) {
      activeSuggestion.classList.remove('active');
      activeSuggestion.nextSibling.classList.add('active');
      activeSuggestion.nextSibling.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    } else if (!activeSuggestion) {
      dropDownSuggestions.firstChild.classList.add('active');
      dropDownSuggestions.firstChild.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    }
  }
  // if the enter key was pressed
  if (event.keyCode === 13 && activeSuggestion) {
    searchField.value = activeSuggestion.textContent.toLowerCase().trim();
    activeSuggestion.classList.remove('active');
  }
}
searchField.addEventListener('keydown', handleArrowKeys);

// search result : integration card & similar card suggestion handled
function searchIntegrations() {
  const inputVal = searchField.value.trim();

  let filteredResults = [];
  if (inputVal.length > 0) {
    filteredResults = integrationData.filter(
      data => data.integration.toLowerCase().includes(inputVal.toLowerCase()),
    );
  }

  const searchResultInner = document.querySelector('.search-result');
  const similarResultInner = document.querySelector('.similar-result');
  similarMsg.classList.remove('d-none');

  const suggestionResultList = filteredResults
    .map(data => `
      <li class="card-item mb-3 mb-5-d">
        <article class="card full-height">
          <a class="card__link" href="${data.link}">
            <span class="visually-hidden">${data.integration} page</span>
            <svg class="card__link-icon" width="24" height="24" fill="#3D6EA8">
              <use xlink:href="#arrow-icon"></use>
            </svg>
          </a>
          <div class="card__main fx fx--c full-height card__main--reg card__main--padding">
            <picture class="card__img">
              <source srcset="https://assets.lexreception.com/lexreception/images/logos/${data.logo}@2x.png 2x, https://assets.lexreception.com/lexreception/images/logos/${data.logo}.png">
              <img src="https://assets.lexreception.com/lexreception/images/logos/${data.logo}.png" alt="${data.integration} logo" height="40">
            </picture>
            <p class="text text--lg tc-primary-700 mt-3">${data.description}</p>
          </div>
        </article>
      </li>
    `).join('');

  const categoryMap = {};
  integrationData.forEach((suggestion) => {
    suggestion.category.forEach((category) => {
      if (!categoryMap[category]) {
        categoryMap[category] = [];
      }
      categoryMap[category].push(suggestion.integration);
    });
  });


  if (filteredResults.length === 0) {
    const resultNotMsg = `<p class="text text--lg">No results found for <span class="bold">&#8220;${inputVal}&#8221;</span></p>`;
    resultMsgInner.innerHTML = resultNotMsg;
    integrationForm.classList.remove('d-none');
    integResult.classList.add('d-none');
  } else {
    const resultFoundMsg = `<p class="text text--lg">Search results for <span class="bold">&#8220;${inputVal}&#8221;</span></p>`;
    resultMsgInner.innerHTML = resultFoundMsg;
    integrationForm.classList.add('d-none');
    integResult.classList.remove('d-none');
  }

  searchResultInner.innerHTML = suggestionResultList;
  similarResultInner.classList.remove('d-none');
}

searchField.addEventListener('keyup', (event) => {
  if (event.key === 'Enter') {
    searchIntegrations();
  }
});

// onclick search dropdown suggestion, added in search input field
dropDownSuggestions.addEventListener('click', (event) => {
  useSuggestion(event);
  dropDownSuggestions.innerHTML = '';
  dropDownSuggestions.classList.remove('has-suggestions');
  searchIntegrations();
  clearTimeout(blurTimeout);
  cardList.classList.add('d-none');
});

document
  .querySelector('#popular-integ-btn')
  .addEventListener('click', () => document.querySelector('[data-category-id="popular-card"]').click());

// search input out of focus, closing search dropdown
searchField.addEventListener('blur', () => {
  blurTimeout = setTimeout(() => {
    dropDownSuggestions.classList.remove('has-suggestions');
    dropDownSuggestions.innerHTML = '';
  }, 100);
});

document.querySelectorAll('.reqIntegrationBtn')
  .forEach(requestBtnElem => requestBtnElem.addEventListener('click', () => {
    cardList.classList.add('d-none');
    integrationForm.classList.remove('d-none');
    integResult.classList.add('d-none');
    const scrollToY = searchContainer.getBoundingClientRect().top + window.pageYOffset - 40;
    window.scrollTo({
      top: scrollToY,
      behavior: 'smooth',
    });
  }));
